import React from 'react';

export default function Footer() {
  return (
    <footer className="py-8 px-4 md:px-12 mt-16 border-t border-gray-800">
      <div className="max-w-6xl mx-auto">
        <p className="text-netflix-gray text-sm text-center">
          &copy; 2024 Cariin. Built with TMDB API. For Portfolio Only.
        </p>
      </div>
    </footer>
  );
}
